import TravelProjectHero from "./TravelProjectHero";

export default TravelProjectHero;
